import { t } from "../../i18n";
import { costCategory } from "./cloud-cost-model";
const serviceKeys: Record<string, string> = {
  "Workers Paid": "workers_paid",
  "Workers for Platforms": "workers_platforms",
  "Durable Objects Compute Duration": "do_duration",
  "Durable Objects Compute Requests": "do_requests",
  "KV Write Operations": "kv_writes",
  "KV Read Operations": "kv_reads",
  "KV List Operations": "kv_list",
  "KV Delete Operations": "kv_delete",
  "R2 Data Storage": "r2_storage",
  "R2 Storage": "r2_storage",
  "R2 Storage Class A Operations": "r2_a",
  "R2 Storage Class B Operations": "r2_b",
  "Durable Objects SQL Storage": "do_sql",
  "Durable Objects Storage": "do_storage",
  "Workers Standard Requests": "workers_requests",
  "Workers CPU Time": "workers_cpu",
};
export function costServiceLabel(service: string): string {
  if (service === "Neon Launch") return t("cost.neon_launch");
  if (service === "Neon Scale") return t("cost.neon_scale");
  const prefix = Object.keys(serviceKeys)
    .sort((a, b) => b.length - a.length)
    .find((name) => service.startsWith(name));
  const exact =
    serviceKeys[service] ?? (prefix ? serviceKeys[prefix] : undefined);
  if (exact) return t(`cost.service.${exact}`);
  const metric = t(`cost.metric.${service}`);
  if (metric !== `cost.metric.${service}`) return metric;
  return t(`cost.category.${costCategory(service)}`);
}
export function costUnitLabel(unit: string): string {
  const units: Record<string, string> = {
    "CU-hour": "cu_hour",
    "GB-month": "gb_month",
    "GB-months": "gb_month",
    "GB-s": "gb_seconds",
    Count: "count",
    "branch-hour": "branch_hour",
    "Capacity-hour": "capacity_hour",
    million: "million",
    bytes: "bytes",
    "GB-seconds": "gb_seconds",
    unit: "count",
    count: "count",
  };
  return units[unit] ? t(`cost.unit.${units[unit]}`) : unit;
}
export function invoiceItemLabel(description: string): string {
  const entry = Object.keys(serviceKeys)
    .sort((a, b) => b.length - a.length)
    .find((name) => description.includes(name));
  if (entry) return costServiceLabel(entry);
  const name = description.toLowerCase();
  if (/tax|gst/.test(name)) return t("cost.tax");
  if (/credit|discount/.test(name)) return t("cost.credit");
  if (/compute/.test(name)) return t("cost.category.compute");
  if (/storage|branch|restore|snapshot/.test(name))
    return t("cost.category.storage");
  if (/transfer|network/.test(name)) return t("cost.category.network");
  return t("cost.category.other");
}
